import React from 'react';
import { useContext, useState, createContext } from 'react';
import DropdownActionContext from '@module:shared/_context/DropdownActionContext';

export default function DropdownActionProvider({ children }) {
    const [isActionOpen, setIsActionOpen] = useState({
        status: false,
        item: null,
        x: 0,
        y: 0,
    });
    return (
        <DropdownActionContext.Provider
            value={{ isActionOpen, setIsActionOpen }}
        >
            {children}
        </DropdownActionContext.Provider>
    );
}
